import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonObject } from "typedjson";
import { DxPageHeaderGroupOptions } from "./dx-page-header-group-options";
/**
 * Класс опций шапки страницы.
 * @publicApi
 */
let DxPageHeaderOptions = class DxPageHeaderOptions {
    /**
     * Класс опций шапки страницы.
     * @publicApi
     */
    constructor() {
        /**
         * Массив групп элементов шапки.
         * @name _groups
         * @type {DxPageHeaderGroupOptions[]}
         * @defaultValue - пустой массив.
         */
        this._groups = [];
    }
    /**
     * Возвращает массив групп элементов шапки.
     * @return {DxPageHeaderGroupOptions[]} - массив групп элементов шапки.
     * @public
     */
    get groups() {
        return this._groups;
    }
    /**
     * Устанавливает массив групп элементов шапки.
     * @param {DxPageHeaderGroupOptions[]} value - массив групп элементов шапки.
     * @public
     */
    set groups(value) {
        this._groups = value;
    }
};
tslib_1.__decorate([
    jsonArrayMember(DxPageHeaderGroupOptions, { name: 'groups', isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Array)
], DxPageHeaderOptions.prototype, "_groups", void 0);
DxPageHeaderOptions = tslib_1.__decorate([
    jsonObject
], DxPageHeaderOptions);
export { DxPageHeaderOptions };
